export const INSIGHTS_USAGE_FETCHER_ACTIONS = {
 FETCH_USAGE_DATA_SUCCESS : 'FETCH_USAGE_DATA_SUCCESS',
 FETCH_USAGE_DATA_FAILURE : 'FETCH_USAGE_DATA_FAILURE',
 FETCHING_USAGE_DATA : 'FETCHING_USAGE_DATA',
 FETCH_CHART_SUMMARY_SUCCESS : 'FETCH_CHART_SUMMARY_SUCCESS',
 FETCH_CHART_SUMMARY_FAILURE : 'FETCH_CHART_SUMMARY_FAILURE'
}

export const INSIGHTS_USAGE_CHART_ACTIONS = {
    UPDATE_CONTROL : 'UPDATE_CONTROL',
    SET_DETECTED_APPLIANCES : 'SET_DETECTED_APPLIANCES',
    UPDATE_ARROWS_STATE : 'UPDATE_ARROWS_STATE',
    UPDATE_OFFSET : 'UPDATE_OFFSET'
}

export function updateControl(payload) {
    return {
        type : INSIGHTS_USAGE_CHART_ACTIONS.UPDATE_CONTROL,
        payload
    }
}

export function usageChartLoading(){
    return{
        type : INSIGHTS_USAGE_FETCHER_ACTIONS.FETCHING_USAGE_DATA
    }
}


export function setDetectedAppliances(detectedAppliances){
    return{
        type : INSIGHTS_USAGE_CHART_ACTIONS.SET_DETECTED_APPLIANCES,
        payload : detectedAppliances
    }
}

export function updateArrowsState(arrowsState){
    return{
        type: INSIGHTS_USAGE_CHART_ACTIONS.UPDATE_ARROWS_STATE,
        payload : arrowsState
    }
}

export function updateOffset(offset){
    return{
        type : INSIGHTS_USAGE_CHART_ACTIONS.UPDATE_OFFSET,
        payload : offset
    }
}